"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalSummaryPagePremiumWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_services_1 = require("@ferry/journey-services");
var RenewalSummaryPagePremiumWidget = /** @class */ (function (_super) {
    __extends(RenewalSummaryPagePremiumWidget, _super);
    function RenewalSummaryPagePremiumWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRenewalProposalPremiumPanel = function (interaction) {
            var _a, _b;
            var changesStartDate = (0, commonFunctions_1.formatDate)(interaction.headerInfo.startDate, "DD MMM YYYY");
            var currentRenewalPrice = interaction.factors.annualPremium;
            var currentTotalPremium = interaction.paymentDetails.instalmentPlan.totalAmount;
            var currentMonthlyPayment = interaction.paymentDetails.instalmentPlan.monthlyPayment;
            var previousRenewalPrice = (_a = interaction.renewalDetails.annualPremium) !== null && _a !== void 0 ? _a : 0;
            var previousRenewalMonthlyPrice = (_b = interaction.renewalDetails.monthlyPremium) !== null && _b !== void 0 ? _b : 0;
            var isMonthlyPayment = interaction.factors.premiumType === journey_services_1.PremiumType.monthly;
            var priceChange;
            if (isMonthlyPayment) {
                priceChange = "".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(previousRenewalMonthlyPrice), " / month\n                            to ").concat((0, commonFunctions_1.getAmountWithDecimalDigits)(currentMonthlyPayment), " / month");
            }
            else {
                priceChange = "".concat((0, commonFunctions_1.getAmountWithDecimalDigits)(previousRenewalPrice), " to ").concat((0, commonFunctions_1.getAmountWithDecimalDigits)(currentRenewalPrice));
            }
            var premiumSpecificWording;
            var noPriceChange = false;
            if (currentRenewalPrice > previousRenewalPrice) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["increased from ", priceChange] });
            }
            else if (currentRenewalPrice < previousRenewalPrice) {
                premiumSpecificWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["reduced from ", priceChange, "."] });
            }
            else {
                premiumSpecificWording = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "not changed." });
                noPriceChange = !noPriceChange;
            }
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel text-center mb-4 policy-change-price", children: [(0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["Your ", !noPriceChange && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "updated" }), " renewal price is ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountWithDecimalDigits)(currentRenewalPrice) })] }), isMonthlyPayment && (0, jsx_runtime_1.jsxs)("p", { className: "margin-bottom-16", children: ["As you've chosen to pay monthly your monthly instalments will be", ' ', (0, commonFunctions_1.getAmountWithDecimalDigits)(currentMonthlyPayment), ". The total you will pay including interest is ", (0, commonFunctions_1.getAmountWithDecimalDigits)(currentTotalPremium), "."] }), (0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-32", children: "All figures include Insurance Premium Tax" }), (0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["Following the changes you've made to take effect from your renewal date (", changesStartDate, "), your renewal price has ", premiumSpecificWording] }), (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: "Please check your renewal tile for further details" })] }));
        };
        return _this;
    }
    RenewalSummaryPagePremiumWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        if (interaction.factors) {
            return this.renderRenewalProposalPremiumPanel(interaction);
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    return RenewalSummaryPagePremiumWidget;
}(plugin_journey_1.WidgetBase));
exports.RenewalSummaryPagePremiumWidget = RenewalSummaryPagePremiumWidget;
//# sourceMappingURL=RenewalSummaryPagePremiumWidget.js.map